import { TARGETS } from '../../../pages/vehicle/[vehicleId]'
import { LinkButton } from '../../../components/button'
import Modal from '../../../components/modal'
import { ROUTES } from '../../../constants'

export default function GetVerified({ onClose, target }) {
  return (
    <Modal onClose={onClose}>
      <div className='wrapper flex flexDirectionColumn alignCenter'>
        <h3>You are not verified</h3>
        <p>
          {target === TARGETS.Offer
            ? 'To offer on the vehicle you need to be a verified user'
            : target === TARGETS.BuyNow
            ? 'To buy the vehicle you need to be a verified user'
            : 'To bid on the vehicle you need to be a verified user'}
        </p>
        <LinkButton href={ROUTES.GetVerified}>Verify</LinkButton>
      </div>

      <style jsx>{`
        .wrapper {
          max-width: 100vw;
          width: 43.6rem;
          padding: 2.8rem 2rem 4.8rem;
          background: #fff;
          border-radius: 1rem;

          h3 {
            font-size: 3.6rem;
          }

          p {
            margin: 2.2rem 0;
            line-height: 2rem;
            font-size: 1.6rem;
          }

          :global(a) {
            text-align: center;
          }
        }
      `}</style>
    </Modal>
  )
}
